import { getAllProducts } from 'api/product';
import { createTrainingVideo, deleteTrainingVideo, updateTrainingVideo } from 'api/trainingVideos';
import { pushAlert, ALERT_TYPES } from 'creatella-react-components/lib/reduxReducers/alerts';
import { handleFetchSingleProduct } from './product';

const FETCH_VIDEOS = 'FETCH_VIDEOS';
const FETCH_VIDEOS_SUCCESS = 'FETCH_VIDEOS_SUCCESS';
const FETCH_VIDEOS_FAILURE = 'FETCH_VIDEOS_FAILURE';

const CREATE_VIDEO = 'CREATE_VIDEO';
const CREATE_VIDEO_SUCCESS = 'CREATE_VIDEO_SUCCESS';
const CREATE_VIDEO_FAILURE = 'CREATE_VIDEO_FAILURE';

const UPDATE_VIDEO = 'UPDATE_VIDEO';
const UPDATE_VIDEO_SUCCESS = 'UPDATE_VIDEO_SUCCESS';
const UPDATE_VIDEO_FAILURE = 'UPDATE_VIDEO_FAILURE';

const DELETE_VIDEO = 'DELETE_VIDEO';
const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO_SUCCESS';
const DELETE_VIDEO_FAILURE = 'DELETE_VIDEO_FAILURE';

const fetchTrainingVideos = (isSearching) => ({
    type: FETCH_VIDEOS,
    isSearching
});

const fetchTrainingVideosSuccess = (data) => ({
    type: FETCH_VIDEOS_SUCCESS,
    data
});

const fetchTrainingVideosFailure = () => ({
    type: FETCH_VIDEOS_FAILURE
});

const createATrainingVideo = (data) => ({
    type: CREATE_VIDEO,
    data
});

const createATrainingVideoSuccess = (data) => ({
    type: CREATE_VIDEO_SUCCESS,
    data
});

const createATrainingVideoFailure = () => ({
    type: CREATE_VIDEO_FAILURE
});

const updateATrainingVideo = (data) => ({
    type: UPDATE_VIDEO,
    data
});

const updateATrainingVideoSuccess = (data) => ({
    type: UPDATE_VIDEO_SUCCESS,
    data
});

const updateATrainingVideoFailure = () => ({
    type: UPDATE_VIDEO_FAILURE
});

const deleteATrainingVideo = () => ({
    type: DELETE_VIDEO
});

const deleteATrainingVideoSuccess = (data) => ({
    type: DELETE_VIDEO_SUCCESS,
    data
});

const deleteATrainingVideoFailure = () => ({
    type: DELETE_VIDEO_FAILURE
});

export function handleFetchTrainingVideos(query) {
    return async (dispatch) => {
        if (!query) {
            query = {
                search: '',
                page: 1,
                training_videos: true
            };
        }

        if (query.search === '') {
            dispatch(fetchTrainingVideos(false));
        } else {
            dispatch(fetchTrainingVideos(true));
        }

        try {
            const { data } = await getAllProducts(query);

            dispatch(fetchTrainingVideosSuccess(data));
        } catch (e) {
            dispatch(fetchTrainingVideosFailure());
        }
    };
}

export function handleCreateTrainingVideo(query) {
    return async (dispatch) => {
        dispatch(createATrainingVideo());

        try {
            const { data: { data } } = await createTrainingVideo(query);

            dispatch(createATrainingVideoSuccess(data));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'Videos added successfully'
            }));
            handleFetchTrainingVideos();
            dispatch(handleFetchSingleProduct(query.product_id));
        } catch (e) {
            dispatch(createATrainingVideoFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Video upload failed'
            }));
        }
    };
}

export function handleUpdateTrainingVideo(productId, videoId, query) {
    return async (dispatch) => {
        dispatch(updateATrainingVideo());

        try {
            const { data: { data } } = await updateTrainingVideo(videoId, query);

            dispatch(updateATrainingVideoSuccess(data));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'Videos updated successfully'
            }));
            handleFetchTrainingVideos();
            dispatch(handleFetchSingleProduct(productId));
        } catch (e) {
            dispatch(updateATrainingVideoFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Updating video failed'
            }));
        }
    };
}

export function handleDeleteTrainingVideo({ productId, videoId }) {
    return async (dispatch) => {
        dispatch(deleteATrainingVideo());

        try {
            await deleteTrainingVideo({ videoId });

            dispatch(deleteATrainingVideoSuccess({ productId, videoId }));
            dispatch(pushAlert({
                type: ALERT_TYPES.SUCCESS,
                message: 'Video deleted!'
            }));
            handleFetchTrainingVideos();
            dispatch(handleFetchSingleProduct(productId));
        } catch (e) {
            dispatch(deleteATrainingVideoFailure());
            dispatch(pushAlert({
                type: ALERT_TYPES.ERROR,
                message: 'Fail removing product'
            }));
        }
    };
}

const INITIAL_STATE = {
    isLoading: true,
    videos: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_VIDEOS:
            return {
                ...state,
                isLoading: !action.isSearching
            };
        case FETCH_VIDEOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                videos: action.data
            };
        case FETCH_VIDEOS_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case CREATE_VIDEO:
            return {
                ...state,
                isLoading: true
            };
        case CREATE_VIDEO_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case CREATE_VIDEO_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case UPDATE_VIDEO:
            return {
                ...state,
                isLoading: true
            };
        case UPDATE_VIDEO_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case UPDATE_VIDEO_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case DELETE_VIDEO:
            return {
                ...state,
                isLoading: true
            };
        case DELETE_VIDEO_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        case DELETE_VIDEO_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        default:
            return {
                ...state
            };
    }
};
